import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Platform, View, Text, Dimensions, StyleSheet, TouchableOpacity } from 'react-native';
import Modal from 'react-native-modal';
import { Picker } from '@react-native-picker/picker';
import IonIcons from '@expo/vector-icons/Ionicons';

import Colors from '../../constants/Colors';
import timeUtils from '../../utils/timeUtils';

function SelectEditCancelVisit(props) {
  const { actions, editOrCancel, visits, translation, locale } = props;

  const [visitId, setVisitId] = useState(visits.length ? visits[0].id : '');
  const [label, setLabel] = useState(translation.select_visit_reschedule);

  useEffect(() => {
    if (editOrCancel == 'edit') {
      setLabel(translation.select_visit_reschedule);
    } else {
      setLabel(translation.select_visit_cancel);
    }
  }, [editOrCancel]);

  const cancelSelect = () => {
    actions.closeSelectEditCancelVisit();
  };

  const selectVisit = () => {
    visits.forEach((visit) => {
      if (visit.id == visitId) {
        actions.selectEditCancelVisit(visit);
      }
    });
  };

  const labels = {
    cancel: translation.app_button_cancel,
    confirm: translation.app_button_confirm,
  };

  const visitItems = [];
  visits.forEach((visit, index) => {
    const visitDate = timeUtils.getDateYear(visit.date * 1000, locale);
    const visitTime = timeUtils.timeSinceMidnightToString(visit.time);
    const label = `${visitDate} ${visitTime}`;
    visitItems.push(<Picker.Item key={`Visit-${index}`} label={label} value={visit.id} />);
  });

  const deviceWidth = Dimensions.get('screen').width;
  const deviceHeight = Dimensions.get('screen').height;

  return (
    <View style={styles.container}>
      <Modal isVisible deviceWidth={deviceWidth} deviceHeight={deviceHeight} style={styles.modal}>
        <View style={styles.modalForm}>
          <View style={styles.contentContaier}>
            <Text style={styles.text}>{label}</Text>
            {Platform.OS === 'web' ? (
              <Picker
                selectedValue={visitId}
                mode="dropdown"
                style={styles.dropdown}
                itemStyle={styles.dropdownItem}
                onValueChange={(itemValue) => setVisitId(itemValue)}
              >
                {visitItems}
              </Picker>
            ) : (
              <Picker
                selectedValue={visitId}
                mode="dropdown"
                style={styles.dropdown}
                itemStyle={styles.dropdownItem}
                onValueChange={(itemValue) => setVisitId(itemValue)}
                iosIcon={<IonIcons name="caret-down-outline" style={styles.icon} />}
              >
                {visitItems}
              </Picker>
            )}
          </View>
          <View style={styles.buttonContainer}>
            <TouchableOpacity onPress={cancelSelect}>
              <Text style={styles.cancelText}>{labels.cancel}</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={selectVisit} style={styles.confirmButton}>
              <Text style={styles.buttonText}>{labels.confirm}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.white,
  },
  modal: {
    alignItems: 'center',
  },
  modalForm: {
    width: 328,
    height: Platform.OS === 'ios' ? 350 : 160,
    backgroundColor: Colors.white,
    borderRadius: 2,
    justifyContent: 'space-between',
  },
  contentContaier: {
    paddingTop: 30,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 24,
    backgroundColor: Colors.white,
  },
  dropdown: {
    height: 50,
    width: '100%',
    borderColor: Colors.white,
  },
  dropdownItem: {
    fontSize: 16,
  },
  buttonContainer: {
    height: 52,
    backgroundColor: Colors.lightGrayBackground,
    borderTopWidth: 1,
    borderTopColor: Colors.grayBorder,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingTop: 8,
    paddingRight: 8,
  },
  text: {
    fontSize: 20,
    lineHeight: 28,
  },
  confirmButton: {
    padding: 10,
    marginBottom: 6,
    backgroundColor: Colors.primaryColor,
    borderRadius: 4,
  },
  cancelText: {
    marginTop: 10,
    marginRight: 20,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  buttonText: {
    color: Colors.white,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
});

SelectEditCancelVisit.propTypes = {
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  translation: PropTypes.objectOf(PropTypes.any).isRequired,
  locale: PropTypes.string.isRequired,
  visits: PropTypes.array.isRequired,
  editOrCancel: PropTypes.string.isRequired,
};

export default SelectEditCancelVisit;
